import { render, staticRenderFns } from "./pure.vue?vue&type=template&id=1a1b7553&lang=pug&"
import script from "./pure.vue?vue&type=script&lang=js&"
export * from "./pure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a1b7553', component.options)
    } else {
      api.reload('1a1b7553', component.options)
    }
    module.hot.accept("./pure.vue?vue&type=template&id=1a1b7553&lang=pug&", function () {
      api.rerender('1a1b7553', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layertree/component/node/pure.vue"
export default component.exports